import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CropperSettings, ImageCropper } from 'ngx-img-cropper';
import { ImageService } from '../../../services/image.service';

@Component({
    selector: 'ig-image-cropper',
    templateUrl: './image.cropper.component.html',
    styleUrls: ['./image.cropper.component.scss'],
})
export class ImageCropperWithPreviewComponent implements OnInit {
    @Input() public icon: string;
    @Input() public imageData: any;
    @Input() public cropperSettings = new CropperSettings();
    @Output() onCropped = new EventEmitter<CroppedEventData>();
    @ViewChild('cropper') public cropper: ImageCropper;
    @ViewChild('cropperWrap') public cropperWrap: ElementRef; //ImageCropper;
    public isLoaded = false;
    public previewWidth: number | string = 0;
    public previewHeight: number | string = 0;

    constructor(public imageService: ImageService) {
        const width = 1228 / 3;
        if (!this.cropperSettings) {
            this.cropperSettings.width = width;
            this.cropperSettings.height = 100;
            this.cropperSettings.croppedWidth = width;
            this.cropperSettings.croppedHeight = 100;
            this.cropperSettings.canvasWidth = width;
            this.cropperSettings.canvasHeight = 0; //250;

            this.cropperSettings.preserveSize = true;
            this.cropperSettings.compressRatio = 1000;
            this.cropperSettings.keepAspect = true;
        }
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.cropperWrap.nativeElement.querySelector('canvas').style.height = '0';
        });
    }

    public cropped($event: CroppedEventData) {
        console.log('$event.width', $event.width);
        const canvasRect = this.cropperWrap.nativeElement.querySelector('canvas').getBoundingClientRect();
        console.log('canvasRect', canvasRect);

        this.previewWidth = canvasRect.width || $event.width;
        this.previewHeight = canvasRect.height || 250;
        this.cropperWrap.nativeElement.querySelector('canvas').style.height = '250px';
        this.onCropped.emit($event);
    }

    public setImageData(settings) {
        this.cropperSettings = settings;
        this.cropperSettings.canvasHeight = 0;
        this.isLoaded = true;
        this.previewWidth = this.cropperSettings.width / 2;
        this.previewHeight = this.cropperSettings.height / 2;
    }

    public setImage(img: any) {
        this.cropper.setImage(img);
    }
}

export interface CroppedEventData {
    bottom: number;
    height: number;
    left: number;
    right: number;
    top: number;
    width: number;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/image.cropper/image.cropper.component.ts